import { useCallback, useEffect, useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { PageHeader, StatusBadge, EmptyState, Pager, Spinner } from "@/components/common";
import BillDrawer from "@/components/BillDrawer";
import { api } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";
import { useAuth } from "@/context/AuthContext";

export default function Reviews() {
  const { user } = useAuth();
  const [status, setStatus] = useState("all");
  const [page, setPage] = useState(1);
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(null);

  const load = useCallback(() => {
    api.get("/reviews", { params: { page, page_size: 25, status: status === "all" ? undefined : status } }).then(({ data: d }) => setData(d));
  }, [page, status]);
  useEffect(() => { load(); }, [load]);

  const title = user.role === "auditor" ? "Review history" : user.role === "staff" ? "Auditor queries" : "Audit reviews";
  return (
    <div>
      <PageHeader eyebrow="Audit" title={title}
        subtitle={user.role === "auditor" ? "Every review action you have recorded." : "Review actions and queries raised by auditors. Open a record to resolve a query."} />
      <div className="panel overflow-hidden fade-up">
        <div className="px-4 py-3 border-b border-slate-200 flex items-center gap-3">
          <div className="w-56">
            <Select value={status} onValueChange={(v) => { setStatus(v); setPage(1); }}>
              <SelectTrigger className="h-9" data-testid="reviews-status-filter"><SelectValue /></SelectTrigger>
              <SelectContent className="bg-white"><SelectItem value="all">All actions</SelectItem><SelectItem value="reviewed">Reviewed</SelectItem><SelectItem value="query_raised">Query raised</SelectItem><SelectItem value="resolved">Resolved</SelectItem></SelectContent>
            </Select>
          </div>
        </div>
        <div className="overflow-x-auto">
          {!data ? <Spinner /> : !data.items.length ? <EmptyState title="No review activity yet" /> : (
            <table className="w-full" data-testid="reviews-table">
              <thead><tr>{["Date (AST)", "Record", "Client", "Invoice", "Action", "Comment", "By"].map((h) => <th key={h} className="th">{h}</th>)}</tr></thead>
              <tbody>
                {data.items.map((r, i) => (
                  <tr key={r.id} className="row-hover cursor-pointer" onClick={() => setOpen(r.bill_id)} data-testid={`review-row-${i}`}>
                    <td className="td num text-xs">{fmtDateTime(r.created_at)}</td>
                    <td className="td num text-xs text-slate-500">{r.record_no}</td>
                    <td className="td">{r.client_name}</td>
                    <td className="td num text-xs">{r.invoice_number}</td>
                    <td className="td"><StatusBadge status={r.status} /></td>
                    <td className="td text-sm text-slate-600 max-w-[320px] truncate">{r.comment || "—"}</td>
                    <td className="td text-xs">{r.by_name}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
        {data && data.total > 0 && <Pager page={page} pageSize={25} total={data.total} onPage={setPage} />}
      </div>
      <BillDrawer billId={open} open={!!open} onOpenChange={(o) => !o && setOpen(null)} onChanged={load} />
    </div>
  );
}
